export const RIDES = '/rides';
export const ADD_RIDE = '/add';
export const BUSES = '/vehicles/buses';
export const TRAMS = '/vehicles/trams';
export const OTHERS = '/vehicles/others';
export const RANKING = '/ranking';
export const STATEMENT = '/statement';
